import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { MessagingService } from '../../core/messaging/messaging.service';

import { AreaPlannerService, ApiService } from "../../_services";
import { IChangeCallback, IStoreFloor } from "../../_entities";
import { IConcept, IConceptTemplate } from '../../_entities';

@Component({
	selector: 'area-planner',
	template: require('./area-planner.template.html')
})

export class AreaPlannerComponent implements OnInit {
	constructor(
		private api: ApiService,
		private areaPlannerService: AreaPlannerService,
		private readonly messagingService: MessagingService) { }

	private _floors: IStoreFloor[];

	@Input() set floors(value: IStoreFloor[]) {
		this._floors = value;
		this.handleMissingConceptTemplates();
	}

	@Input() mode: "" | "store" | "project";

	get floors() {
		return this._floors;
	}

	conceptTemplates: IConceptTemplate[];

	salesAreaTypeId: number = 1;

	ngOnInit() {

		this.api.areaPlanner.getConceptTemplates().then(x => this.conceptTemplates = x);

		this.handleMissingConceptTemplates();
	}

	getConcept(floorId: number, conceptTypeId: number): IConcept {
		const floor = this.floors.find(f => f.id === floorId);
		if (!!floor) {
			const concept = floor.concepts.find(c => c.conceptType.id === conceptTypeId);
			if (concept)
				return concept;
		}

		return null;
	}

	private handleMissingConceptTemplates() {

		//	if (!this.floors || this.floors.length === 0 || !this.conceptTemplates) {
		//		return;
		//	}


		//	this.floors.forEach(sf => {
		//		const floorSalesArea = this.getArea(sf, this.salesAreaTypeId);
		//		if (!floorSalesArea || !floorSalesArea.concept) {
		//			return;
		//		}

		//		let missingConceptTypes: IConceptType[] = [];
		//		this.conceptTemplates.forEach(ct => {

		//			let conceptTypeExists = false;
		//			for (const concept of floorSalesArea.concept) {

		//				if (concept.conceptType.id === ct.conceptType.id) {
		//					conceptTypeExists = true;
		//					break;
		//				}
		//			}

		//			if (!conceptTypeExists) {
		//				missingConceptTypes.push(ct.conceptType);
		//			}
		//		});

		//		missingConceptTypes.forEach(ct => {
		//			floorSalesArea.concept.push(<IConcept>{
		//				id: 0,
		//				area: floorSalesArea,
		//				conceptType: ct
		//			});
		//		});

		//		let missingConceptTemplates: IConceptTemplate[] = [];
		//		floorSalesArea.concept.forEach(c => {

		//			let conceptTypeExists = false;
		//			for (const conceptTemplate of this.conceptTemplates) {

		//				if (conceptTemplate.conceptType.id === c.conceptType.id) {
		//					conceptTypeExists = true;
		//					break;
		//				}
		//			}

		//			if (!conceptTypeExists) {
		//				missingConceptTemplates.push(<IConceptTemplate>{
		//					conceptType: c.conceptType,
		//				});
		//			}
		//		});

		//		missingConceptTemplates.forEach(ct => {
		//			this.conceptTemplates.push(ct);
		//		});

		//	});
	}

	private sendAreaPlannerChanged = () => this.messagingService.publish("areaplanner.changed", null);

	onStoreFloorChange(event: IChangeCallback<any>, storeFloorId: number) {
		this.areaPlannerService.patchStoreFloor(storeFloorId, event.id, event.newValue)
			.then((newFloor) => {

				this.sendAreaPlannerChanged();

				this.floors = this.floors.map(item => item.id === storeFloorId ? newFloor : item);
				event.resolve();
			},
				error => event.reject(error));
	}


	onConceptChange(event: IChangeCallback<any>, conceptId: number) {
		this.areaPlannerService.patchConcept(conceptId, event.id, event.newValue)
			.then(r => this.areaPlannerService.getStoreFloor(r.storeFloorId).then(sf => {

				this.sendAreaPlannerChanged();

				this.floors = this.floors.map(item => item.id === r.storeFloorId ? sf : item);
				event.resolve();
			})
				, error => event.reject(error));
	}

	onAddConcept(event: IChangeCallback<any>, storeFloorId: number, conceptTypeId: number) {

		var data = {};
		data[event.id] = event.newValue;

		this.areaPlannerService.addConcept(storeFloorId, conceptTypeId, data)
			.then(r => this.areaPlannerService.getStoreFloor(r.storeFloorId).then(sf => {
				this.floors = this.floors.map(item => item.id === r.storeFloorId ? sf : item);
				event.resolve();
				this.sendAreaPlannerChanged();
			})
				, error => event.reject(error));
	}


	onAreaFactorChange(event: IChangeCallback<any>, floor: IStoreFloor) {
		console.log("AreaPlannerComponent onAreaFactorChange!");
		const newPlannedArea = floor.contractArea * event.newValue;
		event.newValue = newPlannedArea;
		this.onStoreFloorChange(event, floor.id);
	}


	get totalPlannedArea(): number {
		let total = 0;
		this.floors.forEach(sf => total += this.getTotalPlannedAreaForFloor(sf));
		return total;
	}

	get totalActualArea(): number {
		let total = 0;
		this.floors.forEach(sf => total += this.getTotalActualAreaForFloor(sf));
		return total;
	}

	getContractAreaFactor(): number {
		return (this.totalActualContractArea / this.totalPlannedContractArea) * 100;
	}

	get totalPlannedContractArea(): number {
		let totalContractArea = 0;
		this.floors.forEach(f => totalContractArea += f.contractArea);
		return totalContractArea;
	}

	get totalActualContractArea(): number {
		let totalActualArea = 0;
		this.floors.forEach(f => totalActualArea += this.getTotalActualAreaForFloor(f));
		return totalActualArea;
	}



	getTotalPlannedAreaForFloor(floor: IStoreFloor): number {
		return floor.salesAreaPlanned + floor.stockroomAreaPlanned + floor.staffAreaPlanned + floor.otherAreaPlanned;
	}

	getTotalActualAreaForFloor(floor: IStoreFloor): number {
		let totalActualArea = floor.otherAreaActual + floor.staffAreaActual + floor.stockroomAreaActual;
		totalActualArea += this.getSalesAreaTotalActualArea(floor);
		return totalActualArea;
	}

	getTotalForAreaType(t: string) {
		let total = 0;
		this.floors.forEach(sf => total += !!sf[t] ? <number>sf[t] : 0);
		return total;
	}


	get sumAllConceptActualAreas() {
		let total = 0;
		this.floors.forEach(sf => total += this.getSalesAreaTotalActualArea(sf));
		return total;
	}

	get sumAllConceptPlannedAreas() {
		return this.floors.forEach(sf => this.getSalesAreaTotalPlannedArea(sf));
	}


	getRecommendedAreaText(conceptTemplate: IConceptTemplate): string {
		if (conceptTemplate.recommendedAreaLower && conceptTemplate.recommendedAreaUpper && conceptTemplate.recommendedAreaLower !== conceptTemplate.recommendedAreaUpper) {
			return conceptTemplate.recommendedAreaLower + "-" + conceptTemplate.recommendedAreaUpper;
		}

		if (conceptTemplate.recommendedAreaLower > 0) {
			return conceptTemplate.recommendedAreaLower.toString();
		}

		if (conceptTemplate.recommendedAreaUpper > 0) {
			return conceptTemplate.recommendedAreaUpper.toString();
		}

		return "";
	}

	getSalesAreaConcept(floor: IStoreFloor, conceptTypeId: number): any {

		if (floor && floor.concepts && floor.concepts.length) {
			for (const concept of floor.concepts) {
				if (concept.conceptType.id === conceptTypeId) {
					return concept;
				}
			}
		}

		return { conceptType: { id: conceptTypeId } };
	}

	getSalesAreaTotalPlannedArea(floor: IStoreFloor) {
		let totalPlannedArea = 0;
		if (floor && floor.concepts) {
			floor.concepts.forEach(c => totalPlannedArea += c.plannedArea || 0);
		}
		return totalPlannedArea;
	}

	getSalesAreaTotalActualArea(floor: IStoreFloor) {
		let totalActualArea = 0;
		if (floor && floor.concepts) {
			floor.concepts.forEach(c => totalActualArea += c.actualArea || 0);
		}
		return totalActualArea;
	}

	getSalesAreaTotalConceptPlannedArea(conceptTypeId: number): number {
		let total = 0;
		this.floors.forEach(f => f.concepts.filter(c => c.conceptType.id === conceptTypeId).forEach(a => total += a.plannedArea));
		return total;
	}

	getSalesAreaTotalConceptActualArea(conceptTypeId: number): number {
		let total = 0;
		this.floors.forEach(f => f.concepts.filter(c => c.conceptType.id === conceptTypeId).forEach(a => total += a.actualArea));
		return total;
	}

	getTotalPlannedAreaForSalesArea(): number {
		return this.getTotalForAreaType("salesAreaPlanned");
	}

	getTotalActualAreaForSalesArea(): number {
		return this.sumAllConceptActualAreas;
	}


	get totalPlannedAreaForSalesAreaAllFloors(): number {
		let totalPlannedArea = 0;
		this.floors.forEach(f => {
			f.concepts.forEach(c => totalPlannedArea += c.plannedArea || 0);
		});

		return totalPlannedArea;
	}

	get totalActualAreaForSalesAreaAllFloors(): number {
		let totalActualArea = 0;
		this.floors.forEach(f => {
			f.concepts.forEach(c => totalActualArea += c.actualArea || 0);
		});

		return totalActualArea;
	}

	getAreaPercentage(floor: IStoreFloor, area: number): number {

		if (floor.contractArea !== 0) {
			let rawPercentage = (area / floor.contractArea);

			const factor = Math.pow(10, 2);
			const roundedTempNumber = Math.round(rawPercentage * factor);
			return roundedTempNumber / factor;

		}

		return 0;
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/area-planner/area-planner.component.ts